module.exports = __webpack_public_path__ + "static/media/mockup1.1ba45b09.png";